(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/store/pd-slice.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/store/pd-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const FULFILLED = svs.myProfile.constants.thunkStatus.FULFILLED;
const _svs$myProfile$react$ = svs.myProfile.react.pages.myInformation.myInformationService,
  getTranscriptStatus = _svs$myProfile$react$.getTranscriptStatus,
  postTranscriptOrdering = _svs$myProfile$react$.postTranscriptOrdering,
  getCustomerBankAccountsAsync = _svs$myProfile$react$.getCustomerBankAccountsAsync;
const getCAndI = svs.myProfile.react.shared.helpers.getCAndI;
const getCustomerBankAccounts = RTK.createAsyncThunk('playerdetails/getbankaccounts', async (_, _ref) => {
  let rejectWithValue = _ref.rejectWithValue,
    getState = _ref.getState;
  const playerBankAccountStatus = getState().playerDetails.playerBankAccountStatus.status;
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) || playerBankAccountStatus !== 'initial') {
    return rejectWithValue({
      error: null,
      message: 'already fetched'
    });
  }
  try {
    const _await$getCustomerBan = await getCustomerBankAccountsAsync(),
      bankAccount = _await$getCustomerBan.bankAccount,
      error = _await$getCustomerBan.error;
    if (error) {
      return rejectWithValue(error);
    }
    return bankAccount;
  } catch (_ref2) {
    let error = _ref2.error;
    return rejectWithValue({
      error
    });
  }
});
const fetchTranscriptStatus = RTK.createAsyncThunk('playerdetails/fetchtranscript', async (_, _ref3) => {
  let rejectWithValue = _ref3.rejectWithValue;
  try {
    const response = await getTranscriptStatus();
    if (response !== null && response !== void 0 && response.error) {
      return rejectWithValue(response.error.code);
    }
    return {
      status: 'success',
      error: null,
      data: response === null || response === void 0 ? void 0 : response.data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const orderTranscript = RTK.createAsyncThunk('playerdetails/ordertranscript', async (transcriptType, _ref4) => {
  let rejectWithValue = _ref4.rejectWithValue;
  try {
    const response = await postTranscriptOrdering(transcriptType);
    if (response !== null && response !== void 0 && response.error) {
      return rejectWithValue(response.error);
    }
    return {
      status: 'success',
      error: null,
      data: response.data
    };
  } catch (err) {
    return rejectWithValue(-1);
  }
});
const pdSlice = RTK.createSlice({
  name: 'pd',
  initialState: {
    playerSettings: null,
    playerBankAccount: {},
    playerBankAccountStatus: {
      status: 'initial',
      error: null
    },
    playerInfo: {},
    transcriptOrderStatus: [],
    cAndI: getCAndI()
  },
  reducers: {
    setPlayerInfoData: (state, action) => {
      state.playerInfo = action.payload;
    },
    setMobileConfirmError: (state, action) => {
      state.mobileConfirmError = action.payload;
    },
    setPlayerSettingsData: (state, action) => {
      state.playerSettings = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(fetchTranscriptStatus.fulfilled, (state, action) => {
      state.transcriptOrderStatus = action.payload.data;
    }).addCase(orderTranscript.fulfilled, state => {
      state.transcriptOrderStatus = [...state.transcriptOrderStatus.filter(order => order.OrderType !== '1'), {
        OrderType: '1',
        OrderStatus: 'NOTREADY'
      }];
    }).addCase(getCustomerBankAccounts.fulfilled, (state, action) => {
      state.playerBankAccount = action.payload;
      state.playerBankAccountStatus = {
        status: FULFILLED,
        error: null
      };
    });
  }
});
svs.myProfile.react.store.pd.actions = _objectSpread({
  getCustomerBankAccounts,
  fetchTranscriptStatus,
  orderTranscript
}, pdSlice.actions);
svs.myProfile.react.store.pd.reducer = pdSlice.reducer;

 })(window);